import { useTranslation } from 'react-i18next';
import './charactersCard.css';
import BlackButton from '../../../settings/ui/black-button';

const CharactersSection = () => {
  const { t } = useTranslation();

  return (
    <section className="px-[24px] md:px-[72px] laptop_l:min-h-max py-[32px] flex justify-center items-center mb-[45px]">
      <div className="container-card w-full flex flex-col items-center text-center gap-[12px] rounded-[42px] min-w-[341px] py-[44px] px-[25px]">
        <h3 className="font-display font-medium text-[18px] md:text-[24px] min-w-[297px]">
          {t('library.charactersCard.title')}
        </h3>
        <p className="font-body font-regular text-[14px] md:text-[18px] mb-[30px] min-w-[297px]">
          {t('library.charactersCard.subtitle')}
        </p>

        <div className="flex justify-center z-10">
          <BlackButton />
        </div>
      </div>
    </section>
  );
};

export default CharactersSection;
